<template>
  <div class="page pcgs-page">
    <div class="maintitle">PCGS查询结果</div>
    <div v-if="loading" class="state">查询中...</div>
    <div v-else-if="error" class="state error">{{ error }}</div>
    <template v-else-if="data">
      <div class="summary">
        <div class="summary-title">送评表号：{{ field(['SubmissionNo', 'SubmissionNumber'], submissionNo) }}</div>
        <div class="summary-grid">
          <div><span>PCGS订单号</span><strong>{{ field(['OrderNo', 'OrderNumber'], '暂无') }}</strong></div>
          <div><span>订单状态</span><strong>{{ field(['OrderStatus', 'Status', 'StatusDescription'], '处理中') }}</strong></div>
          <div><span>接收日期</span><strong>{{ date(field(['ReceivedDate', 'DateReceived', 'ReceivedAt'], '暂无')) }}</strong></div>
          <div><span>返还日期</span><strong>{{ date(field(['DateShipped', 'ReturnDate', 'ReturnedDate', 'ReturnAt'], '暂无')) }}</strong></div>
        </div>
      </div>
      <div class="list-title">钱币明细</div>
      <div v-if="products.length" class="products">
        <div class="product" v-for="(item, index) in products" :key="index">
          <div class="product-head">第 {{ productField(item, ['LineNo', 'LineNumber', 'RowNumber'], index + 1) }} 枚</div>
          <div class="product-row"><span>产品号</span><b>{{ productField(item, ['ItemNo', 'ProductNo', 'ProductNumber'], '暂无') }}</b></div>
          <div class="product-row"><span>证书号</span><b>{{ progressField(item, ['CertNo', 'CertificateNo', 'CertificateNumber']) }}</b></div>
          <div class="product-row"><span>PCGS号</span><b>{{ progressField(item, ['PCGSNo', 'PCGSNumber']) }}</b></div>
          <div class="product-row"><span>描述</span><b>{{ productField(item, ['Description', 'Desc'], '暂无') }}</b></div>
          <div class="product-row"><span>评级</span><b>{{ progressField(item, ['DisplayGrade', 'Grade', 'GradeDescription', 'Rating']) }}</b></div>
        </div>
      </div>
      <div v-else class="state">暂无钱币明细，评级完成后会更新结果。</div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.pcgs-page { min-height: 100vh; background: #f5f5f5; padding-bottom: 30px; }
.maintitle { font-size: 20px; margin: 20px; }
.summary, .product { margin: 0 15px 15px; padding: 15px; background: #fff; border-radius: 4px; }
.summary-title { font-size: 16px; font-weight: 500; padding-bottom: 12px; border-bottom: 1px solid #eee; }
.summary-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 12px; padding-top: 14px; }
.summary-grid span, .product-row span { display: block; color: #888; font-size: 13px; margin-bottom: 4px; }
.summary-grid strong, .product-row b { color: #333; font-size: 14px; word-break: break-word; }
.list-title { padding: 0 15px; margin: 20px 0 8px; color: #666; }
.product-head { color: #1989fa; font-weight: 500; margin-bottom: 12px; }
.product-row { padding: 8px 0; border-top: 1px solid #f2f2f2; }
.state { padding: 60px 20px; text-align: center; color: #888; }
.error { color: #e02f21; }
</style>

<script>
export default {
  data () { return { shop_id: null, loading: true, error: '', data: null, submissionNo: '', products: [] } },
  created () { this.submissionNo = this.$route.query.submissionNo; this.shop_id = this.$route.params.shop_id; this.query() },
  methods: {
    async query () {
      if (!this.submissionNo) { this.loading = false; this.error = '缺少PCGS订单号'; return }
      const r = await this.$axios.post('/service/queryPcgs', { submissionNo: this.submissionNo })
      this.loading = false
      if (r.status !== 1) { this.error = r.msg || '查询失败，请稍后重试'; return }
      this.data = r.data
      this.submissionNo = r.submissionNo
      const source = Array.isArray(this.data.Orders) ? this.data.Orders[0] : (Array.isArray(this.data) ? this.data[0] : this.data)
      if (source && Array.isArray(source.OrderLines)) this.products = source.OrderLines
      else {
        const keys = ['OrderDetails', 'OrderDetail', 'OrderItems', 'Products', 'Items', 'SubmissionItems']
        const key = source && Object.keys(source).find(name => keys.some(item => name.toLowerCase() === item.toLowerCase()))
        const value = key && source[key]
        this.products = Array.isArray(value) ? value : ((value && Array.isArray(value.Items)) ? value.Items : [])
      }
    },
    source () { return this.data && Array.isArray(this.data.Orders) ? this.data.Orders[0] : (Array.isArray(this.data) ? this.data[0] : this.data) },
    value (source, keys, fallback) { if (!source || typeof source !== 'object') return fallback; const key = Object.keys(source).find(k => keys.some(name => k.toLowerCase() === name.toLowerCase())); const value = key && source[key]; return value === undefined || value === null || value === '' ? fallback : value },
    field (keys, fallback) { return this.value(this.source(), keys, fallback || '处理中') },
    productField (item, keys, fallback) { return this.value(item, keys, fallback) },
    progressField (item, keys) { return this.value(item, keys, '处理中') },
    date (value) { if (!value || value === '暂无') return value; return String(value).replace('T', ' ').split('.')[0] }
  }
}
</script>
